import { getClasses } from '@/api/class'
import { ElMessage } from 'element-plus'

export default {
  namespaced: true,

  state: {
    classes: [],
    loading: false,
    total: 0,
    filters: {
      grade: null,
      subject: null,
      semester: null,
      type: null,
      campus: null,
      teacher: null,
      enrollment_status: null,
      status: 'active'
    }
  },

  mutations: {
    SET_CLASSES(state, classes) {
      state.classes = classes.map(cls => ({
        ...cls,
        teacher: cls.teacher || '-',
        student_count: cls.current_students || 0
      }))
    },
    SET_LOADING(state, status) {
      state.loading = status
    },
    SET_TOTAL(state, total) {
      state.total = total
    },
    SET_FILTERS(state, filters) {
      state.filters = { ...state.filters, ...filters }
    }
  },

  actions: {
    async fetchClasses({ commit, state }, params = {}) {
      try {
        commit('SET_LOADING', true)
        const cleanParams = { ...state.filters, ...params }
        Object.keys(cleanParams).forEach(key => {
          if (cleanParams[key] === null || cleanParams[key] === undefined || cleanParams[key] === '') {
            delete cleanParams[key]
          }
        })
        
        const response = await getClasses(cleanParams)
        
        if (response.status === 'success') {
          commit('SET_CLASSES', response.data.classes || [])
          commit('SET_TOTAL', response.data.total || 0)
          if (response.data.filters) {
            commit('SET_FILTERS', response.data.filters)
          }
        } else {
          console.error('获取班级列表失败:', response)
          ElMessage.error(response.message || '获取班级列表失败')
        }
      } catch (error) {
        console.error('获取班级列表失败:', error)
        ElMessage.error(error.message || '获取班级列表失败')
      } finally {
        commit('SET_LOADING', false)
      }
    },

    updateFilters({ commit, dispatch }, filters) {
      commit('SET_FILTERS', filters)
      dispatch('fetchClasses')
    }
  },

  getters: {
    classOptions: (state) => {
      return state.classes.map(cls => ({
        value: cls._id,
        label: `${cls.name}（${cls.grade}${cls.subject}）${cls.teacher ? ` - ${cls.teacher}` : ''}`
      }))
    }
  }
} 